<template>
  <div id="app">
    <slot name="menu" :collapse="collapse" v-if="showMenu"/>
    <div class="container">
      <div class="top-nav" align="middle" >
        <el-button
          v-if="showMenu"
          type="primary"
          size="small"
          @click="collapse = !collapse"
          class="collapser">
          <i class="el-icon-fa-bars"/>
        </el-button>
        <div v-if="!showMenu" >
          <a :href="ibcHome" >
            <img src="../../assets/logo.png" height="70" />
          </a>
          <img src="../../assets/bloc_marque_2.png" height="55" />
          <img src="../../assets/logo_gip_alfa__fond_transparent.png" height="70" />
          <img src="../../assets/logo_competences.png" height="55" />
        </div>
        <div class="top-nav-right">
          <template v-if="logged" >
            <my-contract :style="style" />
            <router-link :to="{path:'/logout'}" class="logout" >
              <el-button type="text" :style="style" >
                <span>Déconnexion</span>
                <i class="el-icon-fa-sign-out"/>
              </el-button>
            </router-link>
          </template>
          <router-link v-else :to="{path:'/login'}" class="logout" >
            <el-button type="text" :style="style" >
              <span>Connexion</span>
              <i class="el-icon-fa-sign-in"/>
            </el-button>
          </router-link>
        </div>
      </div>
      <slot name="router"/>
    </div>
  </div>
</template>

<script>
import {MyContract} from '@/contracts/components'

export default {
  components: {
    MyContract
  },
  name: 'layout-chloe-reporting',
  data () {
    return {
      collapse: false
    }
  },
  computed: {
    ibcHome () {
      return window[window.macarons].ibcHome
    },
    logged () {
      return this.$store.state.token !== null
    },
    showMenu () {
      // @todo better criteria
      return this.logged || window[window.macarons].showMenu
    },
    style () {
      return !window[window.macarons].showMenu ? {} : {
        'font-weight': 600
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./../../style/colors.scss";

#app {
  display: flex;
}

.container {
  width: 100%;
}

.top-nav {

  display: flex;
  justify-content: space-between;
  color: $--color-text-secondary;
  padding: 0.2em 0.6em;
  background: $--color-white;
  margin-bottom: 1em;

  .collapser {
    align-self: center;
  }

  .top-nav-right {
    flex: 1;
    display: flex;
    justify-content: flex-end;

    & > * {
      margin-left: 1em;
    }

    .my-contract {
      align-self: center;
      font-size: 14px;
      line-height: 1;
    }

    a.logout {
      align-self: center;
      .el-button {
        color: $--color-text-secondary;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/macarons/components/Layout.vue